<template>
    <div class="burger" :class="{ 'active' : isOpen }">
        <div class="content">
            <div class="burger_menu">
                <a href="/catalog/top" class="burger-catalog">
                    <i class="icon-grid"> </i>
                    Каталог
                </a>
              <a href="/30" class="burger_menu_item" style="color: var(--brandColor)">
                Золотая лихорадка
              </a>
              <a href="/catalog/top-new" class="burger_menu_item" style="color: var(--brandColor)">
                Новинки
              </a>
              <a href="/catalog/top-discount" class="burger_menu_item" style="color: var(--brandColor)">
                Распродажа
              </a>

              <a href="/about" class="burger_menu_item"> <span v-if="!brand">О нас</span><span v-else>О бренде</span> </a>
              <a href="/news" class="burger_menu_item"> <span v-if="!brand">Новости</span><span v-else>Акции</span> </a>
                <a href="/brands" class="burger_menu_item" v-if="!brand"> Бренды </a>
                <a href="/warranty-and-service" class="burger_menu_item">
                    Гарантия и сервис
                </a>
                <a href="/delivery-and-payment" class="burger_menu_item">
                    Доставка и оплата
                </a>
                <a href="/partners" class="burger_menu_item" v-if="!brand"> Партнерам </a>
                <a href="/contacts" class="burger_menu_item"> Контакты </a>
            </div>
            <a href="/where-to-buy" class="burger_whereBuy">
                <i class="icon-loc"> </i>
                Где купить
            </a>
            <a href="tel:+74956642177" class="burger_phone"> 8-495-664-21-77 </a>
            <div style="margin-top: -20px;">Москва</div>
            <a href="tel:88005051834" class="burger_phone"> 8-800-505-18-34 </a>
            <div style="margin-top: -20px;">Россия</div>

            <a href="/customer/private/bio" class="burger_user">
                <i class="icon-user"> </i>
                Личный кабинет
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MenuFloat",
        props: ['brand'],
        computed: {
            isOpen () {
                return this.$store.state.isMenuOpen
            }
        }
    }
</script>